import { Element } from 'src/components';
import { memo } from 'react';
import { IContent } from 'src/interface';
import styles from './style.module.scss';
import { SECTION_ID } from 'src/constants';
import { ContentList } from '../../list';

interface IProps {
    items: IContent[];
    tracking?: string;
    displayTimeIn?: number;
}

export function ContentTopSection(props: IProps) {
    const { items = [], tracking = '', displayTimeIn } = props;

    if (!items.length) {
        return null;
    }

    let top1 = items[0];
    items[0].thumb = items[0]?.thumb.replace('w250_r3x2', 'w400_r16x9') || '';

    return (
        <>
            <Element className={styles['bm-top1-story']}>
                <ContentList
                    sectionId={`${SECTION_ID.CONTENT_LIST_TOP}`}
                    className={styles['content-list-top1']}
                    items={items}
                    tracking={tracking}
                    displayTimeIn={displayTimeIn}
                    hasLayoutPhoto={false}
                    ContentItemProps={{ lazyloadImage: false }}
                />
            </Element>
        </>
    );
}

export default memo(ContentTopSection);
